"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const assert_1 = __importDefault(require("assert"));
function getCenterCost(db, productId) {
    return __awaiter(this, void 0, void 0, function* () {
        const product = yield db.collection('products')
            .findOne({ _id: productId });
        if (product.centerCost == null) {
            console.log(`Missing product.centerCost [${productId}]`);
            return 0;
        }
        return product.centerCost;
    });
}
exports.getCenterCost = getCenterCost;
function getProductId(db, name) {
    return __awaiter(this, void 0, void 0, function* () {
        const product = yield db.collection('products')
            .findOne({ key: name });
        if (product == null) {
            console.log(`Product ${name} is not found.`);
            return null;
        }
        return product._id;
    });
}
exports.getProductId = getProductId;
function getWarehouseId(db, name) {
    return __awaiter(this, void 0, void 0, function* () {
        const warehousing = yield db.collection('parties')
            .findOne({ name });
        assert_1.default(warehousing != null);
        if (warehousing.storageMA !== '執行')
            throw new Error('Storage is wrong.');
        return warehousing._id;
    });
}
exports.getWarehouseId = getWarehouseId;
function getProductKey(barcode) {
    if (barcode == null)
        return null;
    // eslint-disable-next-line
    barcode = barcode.trim();
    if (barcode.length === 0)
        return null;
    const si = barcode.indexOf('#');
    if (si === -1) {
        return barcode;
    }
    // eslint-disable-next-line no-param-reassign
    barcode = barcode.substr(0, si);
    if (barcode.length === 0)
        return null;
    return barcode;
}
exports.getProductKey = getProductKey;
